/** 
 *   营销管理 api
 */
import { get, post, put, del } from '@/untils/axios.js'


/*
 *   主题列表
 */
// 主题 列表
export const subject  = params => get('special/column-list', params)
// 主题 添加
export const subject_add  = params => post('special/column-list', params)
// 主题 修改
export const subject_put   = (id,params) => put(`special/column-list/${id}`, params)
// 主题 删除
export const subject_del   = (id) => del(`special/column-list/${id}`)



/*
 *   主题商品
 */

// 主题商品列表   4 自营商品 5 天天福利  6 新品预售  7 礼物专区  8 优选好货
export const section  = params => get('special/column-goods', params)

// 主题商品 添加
export const section_add   = params => post('special/column-goods', params)

// 主题分类 修改
export const section_put   = (id,params) => put(`special/column-goods/${id}`, params)

// 主题分类 修改
export const section_del   = (id,params) => del(`special/column-goods/${id}`, params)

// 获取预售商品
export const get_pre_sale  = params => get(`presale/goods-list`, params)

// 设置推荐
export const set_rem_presale  = params => post(`presale/goods`, params)

// 获取已推荐列表
export const get_pre_goods  = params => get(`presale/goods`, params)

// 移除推荐
export const del_rem_presale  = id => del(`presale/goods/${id}`)

// 设置推荐排序
export const set_sort_presale  = (id, params) => put(`presale/goods/${id}`, params)




/*
 *   主题分类
 */

// 主题分类 列表
export const classify_list  = params => get('special/column-type', params)

// 主题分类 添加
export const classify_add   = params => post('special/column-type', params)

// 主题分类 修改
export const classify_put   = (id,params) => put(`special/column-type/${id}`, params)

// 主题分类 删除
export const classify_del   = params => del(`special/column-type/${params}` )



/*
 *   主题图片
 */

//  主题图 列表
export const theme_list  = params => get('special/column-banner', params)

// 主题图 添加
export const theme_add   = params => post('special/column-banner', params)

// 主题图 修改
export const theme_put   = (id,params) => put(`special/column-banner/${id}`, params)

// 主题图 删除
export const theme_del   = params => del(`special/column-banner/${params}` )




/*
 *   天天福利
 */

//  天天福利商品 列表
export const welfare_list  = params => get('signin/goods-list', params)

// 签到商品添加商品
export const welfare_goods = params => get('signin/select-goods-list', params) 

// 主题图 添加
export const welfare_add   = params => post('signin/goods-list', params)

// 主题图 修改
export const welfare_put   = (id,params) => put(`signin/goods-list/${id}`, params)

// 主题图 删除
export const welfare_del   = (id,params) => del(`signin/goods-list/${id}`, params )

// 签到统计
export const user_sign   = params => get(`signin/list`, params)



/*
 *   广告位管理
 */

//  广告位位置 列表
export const adv_list  = params => get('banner/place', params)

// 广告位位置 添加
export const adv_add   = params => post('banner/place', params)

// 广告位位置 修改
export const adv_put   = (id,params) => put(`banner/place/${id}`, params)

// 广告位位置 删除
export const adv_del   = params => del(`banner/place/${params}` )

/*
 *   Banner图管理
 */

//  Banner图 列表
export const banner_list  = params => get('banner/main', params)

// Banner图 添加
export const banner_add   = params => post('banner/main', params)

// Banner图 修改
export const banner_put   = (id,params) => put(`banner/main/${id}`, params)

// Banner图 删除
export const banner_del   = params => del(`banner/main/${params}` )




/*
 *   优惠券
 */


// 优惠券 列表
export const coupon_list  = params => get('coupon', params)

// 优惠券 添加
export const coupon_add   = params => post('coupon', params)

// 优惠券 修改
export const coupon_put   = (id,params) => put(`coupon/${id}`, params)

// 优惠券 删除
export const coupon_del   = params => del(`coupon/${params}` )

// 商家优惠券 列表
export const coupon_bg  = params => get('coupon_background', params)

// 商家优惠券 添加
export const coupon_bg_add   = params => post('coupon_background', params)

// 优惠券 修改
export const coupon_bg_put   = (id,params) => put(`coupon_background/${id}`, params)




/*
*  邮费设置
*/ 

// 商家包邮地区显示
export const postageList = params => get('freight/rules', params);

// 修改包邮
export const postageEdit = (id,params) => put(`freight/rules/${id}`,params);


/*
* 消息通知
*/
// 获取历史站内信消息
export const push_list = params => get('/message/push', params)

// 触发消息添加 
export const push_add = params => post('/message/user-push', params) 

// 获取模板消息列表
export const getMbList = (id,params) =>get(`/template/${id}`, params);

// 获取模板消息列表
export const addMb = params => post('/message/push', params)

// 获取模板消息详细数据
export const getMbInfo = (id,params) => get(`/template_info/${id}`, params);

// 删除模板消息
export const delMb = (id,params) => del(`/message/push/${id}`, params);

// 修改模板消息
export const saveMb = (id,params) => put(`/message/push/${id}`, params);

// 开启模板消息
export const openActive  = params => post('/template_select', params);


/*
*   公众号裂变
*/

// 助力裂变
export const wechat_luck_draw = params => get('/wechat_luck_draw', params)

// 公众号裂变
export const marketing_member_list = params => get('marketing/member-list', params)

// 公众号裂变
export const marketing_member_sms = params => post('marketing/member-list-sms', params)

// 领取
export const marketing_member_receive = id => post(`marketing/member-receive/${id}`)

/*
 *   活动专区
 */

// 活动列表
export const active_list = params => get('activity/goods-setting', params)

// 活动 添加
export const active_add = params => post('activity/goods-setting', params)

// 活动 修改
export const active_put = (id,params) => put(`activity/goods-setting/${id}`, params)

// 活动 删除
export const active_del = id => del(`activity/goods-setting/${id}`)

// 活动详情页 商品列表
export const goods_lists = params => get(`activity/goods-list`, params)

// 活动详情页 添加商品
export const goods_add = params => post(`activity/goods-list`, params)

// 活动详情页 修改商品
export const goods_put = (id,params) => put(`activity/goods-list/${id}`, params)

// 活动详情页 修改直播价格
export const live_put = (params) => put(`activity/goods/sku/update/all`, params)

// 活动详情页 移除商品
export const goods_del = id => del(`activity/goods-list/${id}`)

/*
 *   首页主题活动
 */

// 首页主题活动列表
export const activity_theme_list = params => get('activity/theme-setting', params)

// 首页主题活动 添加
export const activity_theme_add = params => post('activity/theme-setting', params)

// 首页主题活动 编辑
export const activity_theme_edit = (id,params) => put(`activity/theme-setting/${id}`, params)

// 首页主题活动 删除
export const activity_theme_del = id => del(`activity/theme-setting/${id}`)

// 首页主题活动详情页 列表
export const theme_goods_list = params => get(`activity/goods-list`, params)

// 首页主题活动详情页 添加
export const add_goods = params => post(`activity/goods-list`, params)

// 首页主题活动详情页 修改
export const edit_goods_sku = (id,params) => put(`activity/goods-list/${id}`, params)

// 首页主题活动详情页 删除
export const del_goods = id => del(`activity/goods-list/${id}`)

/*
 *   获奖名单
 */

// 获奖名单列表
export const record_list = params => get('marketing/gift-record', params)

/*
 *   落地页
 */

// 落地页列表
export const landing_page_list = params => get('activity/landing-setting', params)

// 落地页 添加
export const landing_page_add = params => post('activity/landing-setting', params)

// 落地页 编辑
export const landing_page_edit = (id,params) => put(`activity/landing-setting/${id}`, params)

// 落地页 删除
export const landing_page_del = id => del(`activity/landing-setting/${id}`)

// 落地页详情页 列表
export const landing_goods_list = params => get(`activity/goods-list`, params)

// 落地页详情页 添加
export const landing_add_goods = params => post(`activity/goods-list`, params)

// 落地页详情页 修改
export const landing_edit_goods_sku = (id,params) => put(`activity/goods-list/${id}`, params)

// 落地页详情页 删除
export const landing_del_goods = id => del(`activity/goods-list/${id}`)

/*
 *   夜市砍价活动
 */
// 砍价活动用户列表
export const gift_recode = params => get(`/night/market/gift/recode`, params)

// 套票领取
export const receive = id => put(`/night/market/gift/recode/update/status/${id}`)

/*
 *   平台砍价活动
 */

// 砍价活动商品列表
export const bargain_goods = params => get(`/bargain/goods`, params)

// 添加砍价活动商品
export const add_bargain_goods = params => post(`/bargain/goods`, params)

// 修改砍价活动商品
export const put_bargain_goods = params => put(`/bargain/goods/sku/update/all`, params)

// 商品状态
export const put_bargain_status = (id, params) => put(`/bargain/goods/${id}`, params)

// 平台砍价用户列表
export const bargain_user = params => get(`/bargain/user`, params)

/*
 *   直播砍价活动
 */

// 直播砍价活动商品列表
export const live_goods = params => get(`/live/goods`, params)

// 直播  添加砍价活动商品
export const add_live_goods = params => post(`/live/goods`, params)

// 直播  修改砍价活动商品
export const put_live_goods = (id, params) => put(`/live/goods/${id}`, params)

// 直播  删除商品
export const del_live_goods = id => del(`/live/goods/${id}`)

// 直播商品sku添加
export const add_live_sku = params => post(`/live/goods/sku`, params)

// 直播商品sku修改
export const put_live_sku = (id, params) => put(`/live/goods/sku/${id}`, params)

// 直播砍价用户列表
export const live_user = params => get(`/live/user/join`, params)


/*
 *   刮刮乐
 */

// 礼品 列表
export const gift_list = params => get(`/gift`, params)

// 礼品 添加
export const gift_add = params => post(`/gift`, params)

// 礼品 修改
export const gift_put = (id, params) => put(`/gift/${id}`, params)

// 礼品兑换列表
export const gift_detail = params => get(`/gift/record`, params)

// 礼品兑换
export const gift_exchange = (id, params) => put(`/gift/record/${id}`, params)

// 优惠返利 列表
export const rebate_list = params => get(`/rebate`, params)

// 优惠返利 添加
export const rebate_add = params => post(`/rebate`, params)

// 优惠返利 修改
export const rebate_put = (id, params) => put(`/rebate/${id}`, params)

// 优惠返利 删除
export const rebate_del = id => del(`/rebate/${id}`)

// 返利审核 列表
export const audit_list = params => get(`/rebate/user`, params)

// 返利 审核
export const audit_put = (id, params) => put(`/rebate/user/${id}`, params)

// 兑换码 列表
export const swap_list = params => get(`/cdkey`, params)

// 兑换码 添加
export const swap_add = params => post(`/cdkey`, params)

// 兑换码 修改
export const swap_put = (id, params) => put(`/cdkey/${id}`, params)

// 兑换码 删除
export const swap_del = id => del(`/cdkey/${id}`)